import { Typography } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import s from './Header.module.scss';
import { Instructions } from './Instructions';

/**
 * Верхняя часть контента (карточки + название)
 * @constructor
 */
const Header = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className={s.header}>
        <Typography.Title className={s.header__title} level={2}>
          {t('formFilling.header')}
        </Typography.Title>
      </div>
      <Instructions />
    </>
  );
};

export default React.memo(Header);
